<template>
  <header class="header">
    <a href="/"><Logo class="header__logo"/></a>
    <div class="header__right-actions">
      <WeCallYou class="header__we-call-you" />
      <WeCallYou class="header__we-call-you--mobile" />
      <Menu v-model="display" :elements="elements" />
    </div>
  </header>
</template>

<script>
import { ref } from '@vue/composition-api';
import route from '@/route.js';
import Icon from '@/lego/components/icons/Icon.vue';
import Menu from '@/lego/components/menus/Menu.vue';
import Logo from '@/lego/components/layout/Logo.vue';
import WeCallYou from '@/lego/partials/home/WeCallYou.vue';

export default {
  components: {
    Icon,
    Menu,
    Logo,
    WeCallYou,
  },
  setup() {
    return {
      display: ref(false),
      elements: {
        Simula: [
          {
            'Nueva hipoteca': route('new-mortgage-page.index'),
            'Mejora de condiciones': route('funnel.improve'),
            Calculadora: route('calculator.view'),
          },
        ],
        Servicios: [
          {
            'Tasación oficial': route('official-appraisal.view'),
            'Tasación online': route('appraisal.view'),
          },
        ],
        Nosotros: route('about'),
        Recursos: [
          {
            Blog: route('posts.index'),
            'Centro de Estudios':
              'https://blog.trioteca.com/centro-de-estudios-de-trioteca/',
            'Curso hipotecario': route('mortgageCourse.index'),
            Webinars: route('webinars.index'),
          },
        ],
      },
    };
  },
};
</script>

<style lang="postcss" scoped>
.header {
  @apply z-10 m-auto justify-between transition-all ease-in-out top-0 left-0 sticky items-center flex px-xxxs 2xl:px-giant w-full h-[5.75rem] bg-neutral-white text-neutral-ultradark;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.04);

  &__logo {
    @apply w-[7rem] sm:w-[9.375rem];
  }

  &__right-actions {
    @apply relative flex flex-row items-center gap-x-xxxs lg:pr-[164px] h-full;
  }

  &__we-call-you {
    @apply absolute right-xxxs hidden lg:flex;

    &--mobile {
      @apply lg:hidden;
    }
  }
}
</style>
